export default __webpack_public_path__ + "ffdd5958ac8fc0192de1a8855d128203.png";